import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from '../CoroutineExceptionHandler.mjs';
import {
  safeIsDispatchNeeded2sl03dqd165wc as safeIsDispatchNeeded,
  safeDispatch2vco9v5u7w5xs as safeDispatch,
} from './DispatchedContinuation.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from '../Runnable.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../CoroutineDispatcher.mjs';
import { Delay9umexudtwyie as Delay } from '../Delay.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_DefaultDelay3q9fawcutqbnw as get_DefaultDelay } from '../CoroutineContext.mjs';
import { atomic$int$11d5swdyn6j0pu as atomic$int$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { LockFreeTaskQueue36fqk9kdm4om8 as LockFreeTaskQueue } from './LockFreeTaskQueue.mjs';
import { SynchronizedObject32xqzf15iiskd as SynchronizedObject } from './Synchronized.mjs';
import { NamedDispatcher2rg47sbefduxc as NamedDispatcher } from './NamedDispatcher.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkParallelism(_this__u8e3s4) {
  // Inline function 'kotlin.require' call
  if (!(_this__u8e3s4 >= 1)) {
    var message = 'Expected positive parallelism level, but got ' + _this__u8e3s4;
    throw IllegalArgumentException().o2(toString(message));
  }
  return Unit_instance;
}
function tryAllocateWorker($this) {
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  $this.c1j_1;
  if ($this.a1j_1.kotlinx$atomicfu$value >= $this.y1i_1)
    return false;
  $this.a1j_1.atomicfu$incrementAndGet();
  return true;
}
function obtainTaskOrDeallocateWorker($this) {
  while (true) {
    var nextTask = $this.b1j_1.ak();
    if (nextTask == null) {
      // Inline function 'kotlinx.coroutines.internal.synchronized' call
      // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
      $this.c1j_1;
      $this.a1j_1.atomicfu$decrementAndGet();
      if ($this.b1j_1.q2() === 0)
        return null;
      $this.a1j_1.atomicfu$incrementAndGet();
    } else
      return nextTask;
  }
}
var WorkerClass;
function Worker() {
  if (WorkerClass === VOID) {
    class $ {
      constructor($outer, currentTask) {
        this.f1j_1 = $outer;
        this.e1j_1 = currentTask;
      }
      p12() {
        try {
          var fairnessCounter = 0;
          while (true) {
            try {
              this.e1j_1.p12();
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                handleCoroutineException(EmptyCoroutineContext_instance, e);
              } else {
                throw $p;
              }
            }
            var tmp = this;
            var tmp0_elvis_lhs = obtainTaskOrDeallocateWorker(this.f1j_1);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp.e1j_1 = tmp_0;
            var tmp_1;
            fairnessCounter = fairnessCounter + 1 | 0;
            if (fairnessCounter >= 16) {
              tmp_1 = safeIsDispatchNeeded(this.f1j_1.x1i_1, this.f1j_1);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              safeDispatch(this.f1j_1.x1i_1, this.f1j_1, this);
              return Unit_instance;
            }
          }
        } catch ($p_0) {
          if ($p_0 instanceof Error) {
            var e_0 = $p_0;
            // Inline function 'kotlinx.coroutines.internal.synchronized' call
            // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
            this.f1j_1.c1j_1;
            this.f1j_1.a1j_1.atomicfu$decrementAndGet();
            throw e_0;
          } else {
            throw $p_0;
          }
        }
      }
    }
    initMetadataForClass($, 'Worker', VOID, VOID, [Runnable()]);
    WorkerClass = $;
  }
  return WorkerClass;
}
var LimitedDispatcherClass;
function LimitedDispatcher() {
  if (LimitedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(dispatcher, parallelism, name) {
        super();
        var tmp = this;
        var tmp0_elvis_lhs = isInterface(dispatcher, Delay()) ? dispatcher : null;
        tmp.w1i_1 = tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
        this.x1i_1 = dispatcher;
        this.y1i_1 = parallelism;
        this.z1i_1 = name;
        this.a1j_1 = atomic$int$1(0);
        this.b1j_1 = new (LockFreeTaskQueue())(false);
        this.c1j_1 = new (SynchronizedObject())();
      }
      r13(parallelism, name) {
        checkParallelism(parallelism);
        if (parallelism >= this.y1i_1)
          return namedOrThis(this, name);
        return super.r13(parallelism, name);
      }
      t13(context, block) {
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.LimitedDispatcher.dispatchInternal' call
          this.b1j_1.g1j(block);
          if (this.a1j_1.kotlinx$atomicfu$value >= this.y1i_1) {
            break $l$block_1;
          }
          if (!tryAllocateWorker(this)) {
            break $l$block_1;
          }
          var tmp0_elvis_lhs = obtainTaskOrDeallocateWorker(this);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$block_1;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var task = tmp;
          try {
            var worker = new (Worker())(this, task);
            safeDispatch(this.x1i_1, this, worker);
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              this.a1j_1.atomicfu$decrementAndGet();
              throw e;
            } else {
              throw $p;
            }
          }
        }
      }
      toString() {
        var tmp0_elvis_lhs = this.z1i_1;
        return tmp0_elvis_lhs == null ? this.x1i_1.toString() + '.limitedParallelism(' + this.y1i_1 + ')' : tmp0_elvis_lhs;
      }
      h14(timeMillis, continuation) {
        this.w1i_1.h14(timeMillis, continuation);
      }
      i14(timeMillis, block, context) {
        return this.w1i_1.i14(timeMillis, block, context);
      }
    }
    initMetadataForClass($, 'LimitedDispatcher', VOID, VOID, [Delay()], [1]);
    LimitedDispatcherClass = $;
  }
  return LimitedDispatcherClass;
}
function namedOrThis(_this__u8e3s4, name) {
  if (!(name == null))
    return new (NamedDispatcher())(_this__u8e3s4, name);
  return _this__u8e3s4;
}
//region block: exports
export {
  LimitedDispatcher as LimitedDispatcher3d39tn8ctj55l,
  checkParallelism as checkParallelism305j5epqg3ju0,
  namedOrThis as namedOrThis1pi8a62t67wtr,
};
//endregion

//# sourceMappingURL=LimitedDispatcher.mjs.map
